module.exports = __webpack_public_path__ + "media/images/official/about_yamori_kinugasa-16dbde19170875c577dcec7ec853aa6a.png";